import { Dialog, Notify } from 'quasar'

function toast (message, caption = null, type = '') {
  return Notify.create({
    type,
    message: message,
    caption: caption,
  })
}

async function alert (alert, persistent = true) {
  return new Promise((resolve) => {
    Dialog.create({
      title: alert,
      cancel: !persistent,
      html: true,
      persistent,
    }).onOk(() => {
      resolve(true)
    }).onCancel(() => {
      resolve(false)
    }).onDismiss(() => {
      resolve(false)
    })
  })
}

async function prompt (question, label = null, message = null) {
  return new Promise((resolve) => {
    Dialog.create({
      title: question,
      message: message,
      cancel: true,
      html: true,
      prompt: { model: '', label },
      persistent: true,
    }).onOk(data => {
      resolve(data)
    }).onCancel(() => {
      resolve(false)
    }).onDismiss(() => {
      resolve(false)
    })
  })
}

async function confirm (question, message = null) {
  return new Promise((resolve) => {
    Dialog.create({
      title: question,
      message: message,
      cancel: true,
      html: true,
      persistent: true,
    }).onOk(() => {
      resolve(true)
    }).onCancel(() => {
      resolve(false)
    }).onDismiss(() => {
      resolve(false)
    })
  })
}

export default {
  methods: {
    $toast: toast,
    $alert: alert,
    $prompt: prompt,
    $confirm: confirm,
  },
}
